// extracted by mini-css-extract-plugin
export default {"profile":"UserProfile_profile__1NDw+","fade-in":"UserProfile_fade-in__QTVTB","dropdown":"UserProfile_dropdown__bw4zB"};